import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Response } from '../../../_shared/models';
import { DriverTimerSettings } from '../../../_shared/models/drivers/operations/driver-timer-settings.model';

@Injectable({
  providedIn: 'root'
})
export class DriverTimerSettingsService {

  constructor(private http: HttpClient) { }

  public getDriverTimerSettingsByAccountId(accountId: number): Promise<Response<DriverTimerSettings>> {
    return firstValueFrom(this.http.get<Response<DriverTimerSettings>>(`${environment.apiEndpoint}/drivertimersettings/account/${accountId}`))
  }

  public upsertDriverTimerSettings(driverTimerSettings: DriverTimerSettings): Promise<Response<DriverTimerSettings>> {
    return firstValueFrom(this.http.post<Response<DriverTimerSettings>>(`${environment.apiEndpoint}/drivertimersettings`, driverTimerSettings))
  }
}